module.exports = __webpack_public_path__ + "img/photo.49fcb679.jpg";